/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Add_RuleInputs */

const tr_landing_pricerules_mock_add_rule = /** @type {(inputs: Landing_Pricerules_Mock_Add_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ yeni kural ekle`)
};

const en_landing_pricerules_mock_add_rule = /** @type {(inputs: Landing_Pricerules_Mock_Add_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ add new rule`)
};

const de_landing_pricerules_mock_add_rule = /** @type {(inputs: Landing_Pricerules_Mock_Add_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ neue Regel anlegen`)
};

const ru_landing_pricerules_mock_add_rule = /** @type {(inputs: Landing_Pricerules_Mock_Add_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ добавить правило`)
};

/**
* | output |
* | --- |
* | "+ add new rule" |
*
* @param {Landing_Pricerules_Mock_Add_RuleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_add_rule = /** @type {((inputs?: Landing_Pricerules_Mock_Add_RuleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Add_RuleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_add_rule(inputs)
	if (locale === "de") return de_landing_pricerules_mock_add_rule(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_add_rule(inputs)
	return tr_landing_pricerules_mock_add_rule(inputs)
});